<div class="header">
  @if (themeService.header().hasCloseButton) {
    <app-nav-button icon="close" (clickEvent)="onCloseClicked()" />
  }
  <div class="header-image-container">
    @if (themeService.header().hasGameIcon) {
      <app-game-icon
        [game]="gameId()"
        size="--spacing-2x-large"
        class="game-icon"
        tabindex="0"
        (click)="onGameIconClicked()"
        (keydown.enter)="onGameIconClicked()"
      ></app-game-icon>
    }
    @if (themeService.header().hasGameName) {
      <app-game-title
        [gameId]="gameId()"
        [title]="gameName()"
        [isWordmark]="themeService.header().hasWordmark"
        tabindex="0"
        (click)="onGameTitleClicked()"
        (keydown.enter)="onGameTitleClicked()"
      ></app-game-title>
    }
  </div>
  @if (showBalance()) {
    <app-balance-pill [balance]="balance()" (balanceClickedEvent)="onBalanceClicked()" />
  }
</div>
@let navTabs = tabs();
@if (navTabs && themeService.header().hasTabs) {
  <app-tab-bar
    [tabs]="navTabs"
    buttonType="tab"
    [selectedTabIndex]="selectedTabIndex()"
    [resultsTabId]="resultsTabId"
    [pendingResultsCount]="displayedPendingCount()"
    [showPendingResultsDot]="displayedShowDot()"
    [balance]="balance()"
    (tabSelected)="onTabSelected($event)"
  />
}
